import React, { useState, useEffect } from 'react';
import { 
  Calendar,
  Users, History, ChevronDown
} from 'lucide-react';
import AgendamentosOS from './SubAbas/AgendamentosOS';
import EscalaTecnicos from './SubAbas/EscalaTecnicos';
import HistoricoEscala from './SubAbas/HistoricoEscala';

const CentroAgendamento = () => {
  const [subAbaAtiva, setSubAbaAtiva] = useState('agendamentos');
  const [showDropdown, setShowDropdown] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Verificar se é mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Fechar dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showDropdown && !event.target.closest('.dropdown-container')) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDropdown]);

  // Sub-abas disponíveis
  const subAbas = [
    {
      id: 'agendamentos',
      nome: 'Agendamentos',
      icon: Calendar,
      cor: 'purple'
    },
    {
      id: 'escala-tecnicos',
      nome: 'Escala de Técnicos',
      icon: Users,
      cor: 'blue'
    },
    {
      id: 'historico-escala',
      nome: 'Histórico de Escala',
      icon: History,
      cor: 'green'
    }
  ];

  const renderizarSubAba = () => {
    switch (subAbaAtiva) {
      case 'agendamentos':
        return <AgendamentosOS />;
      case 'escala-tecnicos':
        return <EscalaTecnicos />;
      case 'historico-escala':
        return <HistoricoEscala />;
      default:
        return <div>Sub-aba não encontrada</div>;
    }
  };

  return (
    <div className="space-y-6">
      {/* Header do Centro de Agendamento */}
      <div className="bg-[color:var(--surface)] border border-[color:var(--border)] rounded-lg p-6 text-[color:var(--text-primary)]">
        <div className="flex items-center space-x-3 mb-4">
          <Calendar className="h-8 w-8 text-[color:var(--accent)]" />
          <div>
            <h2 className="text-2xl font-bold">Centro de Agendamento</h2>
            <p className="text-[color:var(--text-muted)]">Controle ativo de OS • Agendamento para técnicos</p>
          </div>
        </div>
      </div>

      {/* Navegação das sub-abas */}
      <div className="bg-[color:var(--surface)] border-b border-[color:var(--border)] rounded-t-lg">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="relative">
            {isMobile ? (
              // Dropdown para mobile
              <div className="dropdown-container">
                <button
                  onClick={() => setShowDropdown(!showDropdown)}
                  className="w-full flex items-center justify-between px-4 py-3 text-left text-sm font-medium text-[color:var(--text-primary)] bg-[color:var(--surface)] border border-[color:var(--border)] rounded-md hover:bg-[color:var(--surface-muted)] focus:outline-none focus:ring-2 focus:ring-[color:var(--accent)]"
                >
                  {subAbas.find(aba => aba.id === subAbaAtiva)?.nome || 'Selecionar sub-aba'}
                  <ChevronDown className="h-4 w-4" />
                </button>
                
                {showDropdown && (
                  <div className="absolute z-10 w-full mt-1 bg-[color:var(--surface)] border border-[color:var(--border)] rounded-md shadow-lg">
                    {subAbas.map((aba) => {
                      const IconComponent = aba.icon;
                      return (
                        <button
                          key={aba.id}
                          onClick={() => {
                            setSubAbaAtiva(aba.id);
                            setShowDropdown(false);
                          }}
                          className={`w-full flex items-center px-4 py-3 text-left text-sm hover:bg-[color:var(--surface-muted)] ${
                            subAbaAtiva === aba.id ? 'bg-[color:var(--surface-muted)] text-[color:var(--accent)]' : 'text-[color:var(--text-primary)]'
                          }`}
                        >
                          <IconComponent className="h-4 w-4 mr-3" />
                          {aba.nome}
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>
            ) : (
              // Tabs para desktop
              <div className="flex space-x-1">
                {subAbas.map((aba) => {
                  const IconComponent = aba.icon;
                  return (
                    <button
                      key={aba.id}
                      onClick={() => setSubAbaAtiva(aba.id)}
                      className={`flex items-center px-4 py-3 text-sm font-medium rounded-t-lg transition-colors ${
                        subAbaAtiva === aba.id
                          ? 'bg-[color:var(--surface)] text-[color:var(--accent)] border-b-2 border-[color:var(--accent)]'
                          : 'text-[color:var(--text-muted)] hover:text-[color:var(--text-primary)] hover:bg-[color:var(--surface-muted)]'
                      }`}
                    >
                      <IconComponent className="h-4 w-4 mr-2" />
                      {aba.nome}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Conteúdo da sub-aba ativa */}
      <div className="bg-[color:var(--surface)] rounded-b-lg shadow-sm border border-[color:var(--border)] p-6">
        {renderizarSubAba()}
      </div>
    </div>
  );
};

export default CentroAgendamento; 

